import script from "./AgentFeedbackOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentFeedbackOverview.vue?vue&type=script&setup=true&lang=js"

import "./AgentFeedbackOverview.vue?vue&type=style&index=0&id=34683bf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34683bf4"]])

export default __exports__